module.exports = "<ota-dialog class=\"dialog-room-note\">\n  <div class=\"title\">\n    {{ 'product-detail-room-note-title' | translate }}\n  </div>\n  <div class=\"item-wrapper\">\n    <div class=\"item\" *ngFor=\"let roomNote of data;\">\n      <i class=\"fa fa-circle\" aria-hidden=\"true\"></i>\n      <div class=\"content\">\n        <div class=\"name\">\n          {{ roomNote?.name }}\n        </div>\n        <div class=\"description\" [innerHtml]=\"roomNote?.description\">\n        </div>\n      </div>\n    </div>\n  </div>\n  \n</ota-dialog>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-room-note/dialog-room-note.component.html
// module id = 1067
// module chunks = 22